



































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import FileUpload from '@/components/controls/file-upload.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';

@Component({
    components: { ModalView, FileUpload },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
            if (val) {
                obj.initForm();
            }
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            }
        }
    }
})

export default class ImportChangesView extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    file: any = null;
    modalSetting: any = {
        entity: "sale",
        width: "95%",
        showForm: false,
        titleFull: 'Importar Listado',
        icon: 'mdi-upload',
        saveText: 'Actualizar CEM',
        saveIcon: 'mdi-upload',
        disabledSave: true,
        customSave: true,
        //showFootActions: false,
        persistent: false
    };

    		


    get columns() {
        let cols = [
            { value: 'number', text: 'TRANSACTION ID', type: 'text', sortable: false },
            { value: 'service_date', text: 'TRANSACTION DATETIME', type: 'text', sortable: false },
            { value: 'dealer_code', text: 'DEALERSHIP_ID', type: 'text', sortable: false },
            { value: 'customer', text: 'FIRST_NAME', type: 'text', sortable: false },
            { value: 'email', text: 'EMAIL_ADDRESS', type: 'text', sortable: false },
            { value: 'lang', text: 'LANGUAGE', type: 'text', sortable: false },
            { value: 'country_name', text: 'COUNTRY', type: 'text', sortable: false },
            { value: 'city', text: 'ASSOCIATE_ID', type: 'text', sortable: false },                
            { value: 'assessor_name', text: 'SURVEY_NAME', type: 'text', sortable: false },                	
            { value: 'vin', text: 'VIN	', type: 'text', sortable: false },
            { value: 'service_type', text: 'SERVICE_TYPE', type: 'text', sortable: false },                	
            { value: 'contact', text: 'FIRST_ALERT_CONTACT', type: 'text', sortable: false },  
            { value: 'address1', text: 'FORM_OF_ADDRESS', type: 'text', sortable: false },     
            { value: 'technician_name', text: 'LAST_NAME', type: 'text', sortable: false },                	
            { value: 'phone', text: 'PHONE_NUMBER', type: 'text', sortable: false },
            { value: 'model', text: 'BRAND', type: 'text', sortable: false },
            { value: 'address2', text: 'CUSTOMER_NUMBER', type: 'text', sortable: false }, 
            { value: 'plate', text: 'AGE_GROUP', type: 'text', sortable: false },                	
            { value: 'seller_name', text: 'CUSTOMER_GENDER', type: 'text', sortable: false },                	
            { value: 'postal_code', text: 'POSTAL_CODE', type: 'text', sortable: false },       
            { value: 'invoice', text: 'CLIENT_SEGMENTATION', type: 'text', sortable: false },                
        ];

        return cols;
    }

    get disabled() {
        if (this.file == null) return true;
        else return false
    }
    get loading() {
        return this.$store.state.sale.loading;
    }
    get list() {
        return this.$store.state.sale.reportList;
    };
    get totalCount() {
        return this.list.length;
    };
    get process() {
        return Util.abp.list.getItem(this.$store.state.sale.process);
    }

    initForm() {
        this.modalSetting.titleFull = "Importar " + this.process.name;
        this.modalSetting.saveText = "Actualizar " + this.process.name;
    }

    async importFile() {
        this.modalSetting.disabledSave = true;
        if (this.file == null) return;

        let formData = new FormData();
        formData.append('file', this.file);
        formData.append('process', this.process.id);

        let result = await this.$store.dispatch({
            type: 'sale/importData',
            data: formData
        });

        if (result) {
            if (this.$refs.fup != undefined)
                (this.$refs.fup as any).removeFile();

            if (this.totalCount > 0) {
                this.$toast.info('Primero Revise los datos Importados, <br/>Luego Presione "Actualizar" para completar el proceso', { timeout: 5000 });
                this.modalSetting.disabledSave = false;
            } else
                this.$toast.warning('No se detectaron cambios en los registros', { timeout: 3000 });
        }
    }

    async save() {
        if (this.totalCount > 0) {

            let newModel = await this.$store.dispatch({
                type: 'sale/updateBatch',
                data: {
                    items: this.list
                }
            });

            this.$toast.success('Registros Actualizados');
            this.$emit('save-success');
            this.cancel();
                           

            return newModel;
        } else
            return false;
    }

    cancel() {
        this.file = null;
        this.$store.commit('sale/setReportList', []);
        this.$emit('input', false);
    }

    mounted() {
    }

    created() {
    }
}
